export enum ServiceProviderStripeOperatedBy {
  None = 'none',
  Pflegenavi = 'pflegenavi',
  ServiceProvider = 'service_provider',
}
